<template>
<toolbar-user></toolbar-user>

  <v-card>
    <v-container fluid>
      <v-row dense>
        <v-col
          v-for="card in cards"
          :key="card.title"
         
          lg="4"
        md="6"
        sm="12"
        
        >
          <v-card width=100%>
            <v-img
            cover
             
             aspect-ratio="2.75"
              :src="card.src"
              class="align-end img"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="300px"
              
            >
              <v-card-title class="text-white" v-text="card.title"></v-card-title>
            </v-img>

            <v-card-actions>
              <v-spacer></v-spacer>

            
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import ToolbarUser from '../components/ToolbarUsers.vue'

export default {
  components:{
ToolbarUser
  },
    data: () => ({
      cards: [
        { title: 'Made for new born', src: require('@/assets/img3.png'), flex: 4 },
        { title: 'Made for wedding', src: require('@/assets/img6.png'), flex: 4 },
          { title: 'Made for nickless', src: require('@/assets/img4.png'), flex: 4 },
        { title: 'Made for wedding', src: require('@/assets/img5.png'), flex: 4 },
        { title: 'Made for wedding', src:require('@/assets/img6.png'), flex: 4 },
        { title: 'Made for wedding', src: require('@/assets/img7.png'), flex: 6 },
        { title: 'Made for wedding', src: require('@/assets/img8.png'), flex: 6 },
        { title: 'Made for watch', src: require('@/assets/img10.png'), flex: 4 },
        { title: 'Made for nickless', src: require('@/assets/img9.png'), flex: 4 },
        { title: 'Made for nickless', src: require('@/assets/img11.png'), flex: 4 },
        { title: 'Made for keychain', src: require('@/assets/img12.png'), flex: 4 },
        { title: 'Made for keychain', src: require('@/assets/img13.png'), flex: 4 },
        
      ],
    }),
  }
</script>
<style scoped>
.img{
  width: 100%;
  height: 100%;
}
</style>